export const ITEM_PER_PAGE = 10;

